export function filterMapValues<T, U>(
    record: Record<string, T>,
    mapFn: (value: T, key: string) => U | null | undefined
): Record<string, U> {
    const result: Record<string, U> = {}
    for (const [key, value] of Object.entries(record)) {
        const newValue = mapFn(value, key)
        if (newValue !== null && newValue !== undefined) {
            result[key] = newValue
        }
    }
    return result
}
